import { translateLocaleSentence } from '../services/locale.shared-service';
import { type TranslationKeys } from '../types/locale';
import { type ErrorResponse } from './../../shared/types/error';

export function getErrorDetails(
	details: ErrorResponse['error']['details'] | undefined,
	locale: (key: TranslationKeys) => string = (key: TranslationKeys) => key
): string | undefined {
	if (!details) return;
	return Object.entries(details)
		.map(
			([field, messages]) =>
				`${field}: ${messages.map((message) => translateLocaleSentence(message, locale)).join(', ')}`
		)
		.join('\n');
}
